import $http from '@/utils/http'

export function doGet(url) {
	return $http.get(url);
}
export function doPost(url, data) {
	return $http.post(url, data);
}




// 红十字会开始
export function leftData() {
	return $http.get('/api/phone/data/leftData')
}
export function centerData() {
	return $http.get('/api/phone/data/centerData')
}
export function rightData() {
	return $http.get('/api/phone/data/rightData')
}


// 红十字会结束